var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"bd-team"}},[_vm._v(" 我的团队 ")])}
var staticRenderFns = []

export { render, staticRenderFns }